module.exports = __webpack_public_path__ + "static/media/funilylogo.7fe36218.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/funilylogo.png
// module id = 250
// module chunks = 0